module.exports = __webpack_public_path__ + "img/fourth.6c2f510b.png";